import type { Report } from '@/types';

/**
 * Utility functions for report and status labels
 * Centralized to avoid duplication across components
 */

export const getIssueLabel = (issue: Report['issue']): string => {
  switch (issue) {
    case 'no_fiber': return 'Fibra non disponibile';
    case 'slow_speed': return 'Velocità troppo bassa';
    case 'connection_issues': return 'Problemi di connessione';
    case 'service_unavailable': return 'Servizio non disponibile';
    case 'other': return 'Altro';
    default: return issue;
  }
};

export const getPriorityLabel = (priority: Report['priority']): string => {
  switch (priority) {
    case 'low': return 'Bassa';
    case 'medium': return 'Media';
    case 'high': return 'Alta';
    case 'urgent': return 'Urgente';
    default: return priority;
  }
};

export const getStatusLabel = (status: Report['status']): string => {
  switch (status) {
    case 'open': return 'Aperta';
    case 'in_progress': return 'In Corso';
    case 'resolved': return 'Risolta';
    case 'closed': return 'Chiusa';
    default: return status;
  }
};

export const getStatusColor = (status: Report['status']): string => {
  switch (status) {
    case 'open': return 'bg-red-100 text-red-800';
    case 'in_progress': return 'bg-yellow-100 text-yellow-800';
    case 'resolved': return 'bg-green-100 text-green-800';
    case 'closed': return 'bg-gray-100 text-gray-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

export const getPriorityColor = (priority: Report['priority']): string => {
  switch (priority) {
    case 'urgent': return 'bg-red-100 text-red-800';
    case 'high': return 'bg-orange-100 text-orange-800';
    case 'medium': return 'bg-yellow-100 text-yellow-800';
    case 'low': return 'bg-blue-100 text-blue-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

// Technology related labels (used in forms)
export const getTechnologyLabel = (technology: string): string => {
  switch (technology) {
    case 'ADSL': return 'ADSL';
    case 'VDSL': return 'VDSL';
    case 'FTTC': return 'FTTC (Fibra misto rame)';
    case 'FTTH': return 'FTTH (Fibra ottica)';
    case 'FWA': return 'FWA (Wireless)';
    case 'Satellite': return 'Satellite';
    case 'Mobile': return 'Mobile';
    case 'None': return 'Nessuna connessione';
    case 'Unknown': return 'Sconosciuta';
    default: return technology;
  }
};

// Speed unit labels
export const getSpeedUnitLabel = (unit: string): string => {
  switch (unit) {
    case 'Kbps': return 'Kbps';
    case 'Mbps': return 'Mbps';
    case 'Gbps': return 'Gbps';
    default: return unit;
  }
};